import { render, staticRenderFns } from "./ExpertiseCard.vue?vue&type=template&id=2564f185&scoped=true&"
import script from "./ExpertiseCard.vue?vue&type=script&lang=ts&"
export * from "./ExpertiseCard.vue?vue&type=script&lang=ts&"
import style0 from "./ExpertiseCard.vue?vue&type=style&index=0&id=2564f185&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564f185",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
